// External libraries
import gql from 'graphql-tag';

export const ADDRESS_AUTOCOMPLETE_FROM_POSTAL_CODE_QUERY = gql`
  query AddressAutocompleteFromPostalCodeQuery(
    $postalCode: String!
    $token: String!
    $country: CountryCodes
  ) {
    addressNormalization(
      postalCode: $postalCode
      token: $token
      processMode: FASTCOMPLETION
      scope: STREET_LEVEL
      country: $country
    ) {
      line1
      line2
      city
      state
      postalCode
    }
  }
`;
